var React = require('react');

function Menu24px (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"fill":"currentColor","d":"M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z","key":1})]);
}

Menu24px.defaultProps = {"height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Menu24px;

Menu24px.default = Menu24px;
